import React, { useEffect } from "react";
import useState from "react-usestateref";
import Pagination from "@material-ui/lab/Pagination";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import apiService from "../core/service/detail";
import { toast } from "react-toastify";

import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import * as Icons from "@material-ui/icons";
import PdfImage from "../images/PDF_file_icon.svg.png";
import SearchBar from "./searchbar";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";
import Skeleton from "react-skeleton-loader";

function Jobapplyerlist() {
  const [currentPage, setCurrentPage] = useState(1);
  const [jobApplyers, setjobApplyers, jobApplyersref] = useState([]);
  const [totalPage, setTotalpages] = useState(0);
  const [activefilter, setActivefilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [toDate, setToDate] = useState("");

  var classes = useStyles();
  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const handlePageChange = (pageNumber) => {
    getJobApplyers(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };
  const [pageloader, setpageloader] = useState(true);
  useEffect(() => {
    getJobApplyers();
  }, []);

  const getJobApplyers = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      };

      var data = {
        apiUrl: apiService.get_beleaf_Job_applyers,
        payload: payload,
      };

      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);

      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setjobApplyers(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseStatus = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "closed",
      };
      var data = {
        apiUrl: apiService.changejobapplierstatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        toast.success(resp.message);
        getJobApplyers();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };
  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getJobApplyers(1);
  };

  const handleExportCourseContacts = async () => {
    try {
      if (!activefilter) {
        const response = await postMethod({
          apiUrl: apiService.exportCourseContactList,
          payload: {},
        });

        if (response.success && response.data?.length) {
          const data = response.data;
          const formattedData = data.map((item) => ({
            Name: item.name || "-",
            Degree: item.degree || "-",
            Mobile: item.mobile || "-",
            Experience: item.experience || "-",
            Resume: item.resume || "-",
            Status: item.status === "open" ? "Open" : "Closed" || "-",
            "Created At": item.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(formattedData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Job Applyers");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(blob, "Job_applyer_list.xlsx");
        } else {
          alert("No data available for export.");
        }
      } else {
        const data = jobApplyersref.current || [];
        const formattedData = data.map((item) => ({
          Name: item.name || "-",
          Degree: item.degree || "-",
          Mobile: item.mobile || "-",
          Experience: item.experience || "-",
          Resume: item.resume || "-",
          Status: item.status === "open" ? "Open" : "Closed" || "-",
          "Created At": item.createdAt
            ? new Date(item.createdAt).toLocaleString()
            : "-",
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Job Applyers");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Job_applyer_list.xlsx");
      }
    } catch (error) {
      console.error("Export failed", error);
      alert("Failed to export Job Applyer List.");
    }
  };

  return (
    <>
      <div>
        {" "}
        <div className={`${classes.jobApplyer_div} mb-4 flex-wrap`}>
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Beleaf Job Applyers List
          </Typography>
          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              className="mb-3"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
            />

            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
            <Button
              className={classes.btn_export}
              variant="outlined"
              color="primary"
              onClick={handleExportCourseContacts}
            >
              <i class="fas fa-file-excel"></i> Export
            </Button>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table className="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Degree</th>
                  <th>Mobile</th>
                  <th>Experience</th>
                  <th>Resume</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : jobApplyersref.current &&
                  jobApplyersref.current.length > 0 ? (
                  jobApplyersref.current.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.name || "-"}</td>
                      <td>{item.degree || "-"}</td>
                      <td>{item.mobile || "-"}</td>
                      <td>{item.experience || "-"}</td>
                      <td>
                        <img
                          style={{ width: "20px", marginRight: "10px" }}
                          src={PdfImage}
                          alt="pdf"
                        />
                        <a
                          href={item.resume}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </td>
                      <td>{moment(item.createdAt).format("lll")}</td>
                      <td className="btn_clr_change">
                        {item.status === "open" ? (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleCloseStatus(item)}
                          >
                            Open
                          </button>
                        ) : (
                          <button className="btn btn-sm btn-danger" disabled>
                            Closed
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="no-record">
                    <td colSpan={12}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* <Pagination
        itemClass="page-item" // add it for bootstrap 4
        linkClass="page-link" // add it for bootstrap 4
        activePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
      </div>
    </>
  );
}

export default Jobapplyerlist;
